module.exports = __webpack_public_path__ + "static/media/lv-graphic-logo-2.5c9fc44d.png";